import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { setFormData } from '../../redux/actions';
import ReactLib from '@owenscorning/react-library'


const { Connect: { Spinner, ReactUtils: { useDebounce, useLoading }, FormElements: { Form, Text } } } = ReactLib

const resultsPerPage = 20
const apiUrl = (value) => `${MDMS_URL}/api/v1/contractor/member_profiles/search?q=${encodeURIComponent(value)}&per_page=${resultsPerPage}`
const fieldKey = 'installingContractor'
const dataKey = 'installingContractorData'
const elId = 'installing-contractor-input'
const minQueryLength = 3

// I'm using datalist since it works pretty well out of the box, and we don't otherwise have an in-brand search-select component
// the limitation is- it requires that we serialize to a string "value"(attribute) whichs gets displayed
// there could be a work-around where we hack a better serializing into the <option>s as data-attributes but this seemed okay
const contractorObjectToString = (obj) => {
  const { membership_number, company_name, company_dba, company_city } = obj
  return `${membership_number || ''}: ${company_name || ''}, ${(company_dba && (company_dba + ', ')) || ''}${company_city || ''}`
}

// find the contractor that matches our input string
const contractorForString = (str, contractors) => {
  if (!str || str.length <= minQueryLength) { return null }
  const matchedContractor = contractors.find(contractor => {
    let contractorString = contractorObjectToString(contractor)
    return contractorString == str
  })
  return matchedContractor || null
}

const ContractorSearch = ({ formData, setFormData }) => {
  const didMount = useRef(false);
  const { installingContractor } = formData
  const [loadWrapper, loading, loadError] = useLoading()
  const [contractors, setContractors] = useState([]);
  const fetchContractors = loadWrapper(async (searchValue) => {
      console.log('sending contractor search request', searchValue)
      const response = await fetch(apiUrl(searchValue)).then(response => response.json())
      console.log('got response', { response })
      setContractors(response)
    })
  const [debounceFetch, cancelDebounceFetch] = useDebounce(fetchContractors)
  useEffect(() => {
    // don't need to run on initial render, has unintended effects on step revisits
    if (!didMount.current) { didMount.current = true; return }
    // check if our input's value is actually one of the contractor options
    // if so set installingContractorData 
    const matchedContractor = contractorForString(installingContractor, contractors)
    matchedContractor && cancelDebounceFetch() // we clicked the data list option, don't do another search
    setFormData({ [dataKey]: matchedContractor })
  }, [installingContractor, contractors])

  const onTextChange = (nextVal) => {
    setFormData({ [fieldKey]: nextVal })
    if (nextVal.length >= minQueryLength) { debounceFetch(nextVal) }
  }

  if (loadError) {
    console.error(loadError.stack);
    throw loadError;
  }

  return (
    <div>
      <Text
        value={installingContractor}
        onChange={onTextChange}
        htmlAttributes={{
          placeholder: 'Search Contractors',
          list: elId
        }}
      />
      {loading && <Spinner />}
      <datalist id={elId}>
        {contractors.map((suggestion, i) =>
          <option key={i}>
            {contractorObjectToString(suggestion)}
          </option>
        )}
      </datalist>
    </div>
  )
}

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const mapDispatchToProps = dispatch => (
  {
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorSearch);
